import { render, staticRenderFns } from "./custom-sizer.vue?vue&type=template&id=61f40a51&"
import script from "./custom-sizer.vue?vue&type=script&lang=js&"
export * from "./custom-sizer.vue?vue&type=script&lang=js&"
import style0 from "./custom-sizer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports